import on from './on/index.js';
import checkObjectType from './_helpers/checkobjecttype.js';
import forOwn from './_helpers/forown.js';
import off from './off/index.js';
import apply from './_helpers/apply.js';
export default function once(object, names, givenCallback, context) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    context = givenCallback;
    givenCallback = names;
    names = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'once');
  }
  var isNamesVarArray = Array.isArray(names);
  // allow to pass name-handler object
  if (names && typeof names === 'object' && !isNamesVarArray) {
    forOwn(names, function (namesObjCallback, namesObjName) {
      return once(object, namesObjName, namesObjCallback, givenCallback);
    });
    return object;
  }
  var called = false;
  var callback = function onceCallback() {
    // a trigger that started before the listener was removed still reaches it
    if (called) return;
    called = true;
    // remove event listener before its call, so the handler can fire its own event again
    off(object, names, onceCallback, context);
    apply(givenCallback, this, arguments);
  };
  // allow to remove event listener py passing original callback to "off"
  callback._callback = givenCallback;
  callback._kind = 'once';
  return on(object, names, callback, context);
}